// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"c728707d","453":"c87fa9ab"}[chunkId] + ".chunk.js";
};